import { render, staticRenderFns } from "./ItemIconContent.vue?vue&type=template&id=7c614f56&lang=pug"
import script from "./ItemIconContent.vue?vue&type=script&lang=ts"
export * from "./ItemIconContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports